<!--
 * @Description: 
 * @Autor: jyf
 * @Date: 2021-06-29 14:36:24
 * @LastEditors: yinwenxuan yinwenxuan@vip56.cn
 * @LastEditTime: 2024-05-27 10:02:26
-->

<template>
    <div class="key-board" >
        <div class="keyleft">
            <div class="keys">
                <div class="key button" v-for="num in config.loop" :key="num.key" @click="number(num.number)">{{num.number}}</div>
                <div class="key button"  v-if="!isNeedDot"></div>
                <div class="key button"  v-else @click="number('.')">.</div>
                <div class="key button key0" @click="number(0)">0</div>
                
            </div>
        </div>
        <div class="keyright">
            <div class="key button" @click="del">
                <img src="https://sinostorage.oss-cn-hangzhou.aliyuncs.com/fms/AAFDC5FB-C573-4196-89DD-4EBD3B9CBD5E.png" style="width: 6.93vw;height: 5.33vw;">
            </div>
            <div class="key button keyconfirm" @click="confirm">
                收款
            </div>
        </div>
    </div>  
  </template>
  
  
  <script>
  export default {
    props: {
          open: {
              type: Boolean,
              default: true
          },
          color: {
              type: String,
              default: '#04BE02'
          },
          isNeedDot: {
              type: Boolean,
              default: false
          }
      },
    data() {
      return {
        config :{
                  loop : [
                      {
                          number : 1,
                          key : 'number-1',
                      },
                      {
                          number : 2,
                          key : 'number-2',
                      },
                      {
                          number : 3,
                          key : 'number-3',
                      },
                      {
                          number : 4,
                          key : 'number-4',
                      },
                      {
                          number : 5,
                          key : 'number-5',
                      },
                      {
                          number : 6,
                          key : 'number-6',
                      },
                      {
                          number : 7,
                          key : 'number-7',
                      },
                      {
                          number : 8,
                          key : 'number-8',
                      },
                      {
                          number : 9,
                          key : 'number-9',
                      },
                  ]
              },
  
      };
    },
    watch: {
          showKeyBoard: function(value, oldValue) {
              if (value == false) {
                  this.$emit('close');
              }
          },
          open: function(value, oldValue) {
              console.log(value);
              this.showKeyBoard = value;
          }
      },
  
    methods: {
      close(){
              this.showKeyBoard = false;
              this.$emit("close");
          },
          del() {
              this.$emit("delete");
          },
          confirm() {
            this.$emit("confirm");
          },
          number(number) {
            console.log('number',number);
              this.$emit("number", number);
          }
  
    },
    onLoad() {
    },
    onShow() {},
    mounted() {
      
  
    }
  
  };
  </script>
  
  <style lang="scss" scoped>
  .key-board {
      width: 100%;
    margin:0 auto;
    display: flex;
    box-sizing: border-box;
    justify-content:center;
    padding-bottom:1.33vw;
    // margin:0 20rpx;
    .keyleft {
        width:72vw;
    }
    .keyright {
        display:flex;
        flex-direction:column;
        // width:calc(100% - 544rpx);
    }
      .title {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 8vw;
          background: #eeeeee;
      }
      .keys {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          
      }
      .key {
        width: 24vw;
        height: 13.33vw;
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #eeeeee;
        box-sizing: border-box;
        font-size: 6.4vw;
        color: #000000;
        &.key0 {
            width:48vw;
        }
        &.keyconfirm {
            width: 24vw;
            height:42.13vw;
            background: linear-gradient(24deg, #B99E62 0%, #CEB57D 99%), #CEB57D;
            color: #FFFFFF;
            font-size: 4.8vw;
        }
    }
    .key:nth-child(n + 4) {
        border-top: 1px solid #eeeeee;
        // border-bottom: 1px solid #eeeeee;
        box-sizing: border-box;
    }
    .key:active {
        background: #dddddd;
    }
      .container {
          width: 100%;
          .count-text {
              justify-content: center;
              align-items: center;
              display: flex;
              /*height: 100px;*/
              /*background: #eee;*/
              font-size: 2.4vw;
          }
      }
      .numberkeyboard-popup {
          width: 100%;
          z-index: 10;
          .count-text {
              position: fixed;
              top: -100px;
              font-size: 28px;
              color: #ffffff;
              width: 100%;
              text-align: center;
              font-weight: 500;
              span {
                  padding: 0 40px;
                  border-radius: 30px;
                  background: -webkit-linear-gradient(left top, #999999, #777777);
              }
          }
          .desc-text {
              position: fixed;
              top: -40px;
              font-size: 12px;
              color: #ffffff;
              width: 100%;
              text-align: center;
              font-weight: 100;
          }
          .number {
              height: 70px;
              line-height: 70px;
              font-size: 25px;
              font-weight: 400;
              color: #666666;
              border-right: 1px solid #999999;
              box-sizing: border-box;
          }
          .number:nth-child(n + 4) {
              border-top: 1px solid #999999;
              box-sizing: border-box;
          }
          .number:active {
              background: #04be02;
              color: #ffffff;
              border: 0px solid #000000;
              box-shadow: 0 0 2px 2px #09bb07;
              box-sizing: border-box;
          }
          .number[data-value='.'] {
              font-weight: 900;
              font-size: 30px;
          }
          .del {
              height: 140px;
              vertical-align: middle;
              line-height: 140px;
              border-bottom: 0.1px solid #999999;
              box-sizing: border-box;
          }
          .del i {
              font-size: 35px;
              color: #666666;
          }
          .confirm {
              font-size: 15px;
              height: 140px;
              line-height: 140px;
              color: #ffffff;
          }
      }
  }
  
  </style>


// WEBPACK FOOTER //
// src/components/newNumberKeyboard.vue